import { Button, ButtonGroup, Flex, Text } from "@chakra-ui/react"
import format from "date-fns/format"
import React, { useMemo } from "react"
import { NavLink } from "react-router-dom"
import { ExtendedUserFragment, MeUserFragment, PhoneDeviceStatus, useMeQuery, UserRoleTypes } from "../../graphql"
import { checkForPermissions } from "../../utils"
import { Card, Stat } from "../common"

export type UserPhoneDeviceDetailsProps = {
	user: ExtendedUserFragment | MeUserFragment
	disableActions?: boolean
}

export const UserPhoneDeviceDetails: React.FC<UserPhoneDeviceDetailsProps> = ({ user, disableActions }) => {
	const [{ data }] = useMeQuery()

	const canAssign = useMemo(() => {
		if (user.phoneDevice) return false
		if (user.isBlacklisted) return false
		if (user.type.roleType === UserRoleTypes.Admin) return false

		return checkForPermissions(data?.me, "phone-devices/assign-phone-device")[0]
	}, [data, user])

	const canUnassign = useMemo(() => {
		if (!user.phoneDevice) return false
		if (user.type.roleType === UserRoleTypes.Admin) return false
		return checkForPermissions(data?.me, "phone-devices/unassign-phone-device")[0]
	}, [data, user])

	return (
		<Card
			title="Phone Device"
			action={
				disableActions ? (
					<></>
				) : (
					<ButtonGroup>
						{canAssign && (
							<Button as={NavLink} to={`/users/${user._id}/assignPhoneDevice`} colorScheme="primary" size="sm">
								Assign
							</Button>
						)}
						{canUnassign && (
							<Button as={NavLink} to={`/users/${user._id}/unassignPhoneDevice`} colorScheme="error" size="sm">
								Unassign
							</Button>
						)}
					</ButtonGroup>
				)
			}
		>
			<Flex justify="center" align="center" flexWrap="wrap">
				<Stat label="Name" value={user.phoneDevice?.label.name || "Not available"} />
				<Stat label="ID" value={user.phoneDevice?.deviceId || "Not available"} />
				<Stat
					label="Status"
					value={
						user.phoneDevice?.status === PhoneDeviceStatus.Assigned ? (
							<Text color="success.600">Assigned</Text>
						) : user.phoneDevice?.status === PhoneDeviceStatus.Inactive ? (
							<Text color="error.600">Inactive</Text>
						) : (
							user.phoneDevice?.status || "Not available"
						)
					}
				/>
				<Stat label="Assigned Since" value={user.phoneDevice?.assignedAt ? format(new Date(user.phoneDevice.assignedAt), "MMM dd, yyyy HH:mm") : "Not available"} />
			</Flex>
		</Card>
	)
}
